module.exports = __webpack_public_path__ + "assets/img/img-map-sp.317e0c2e.png";